<template>
  <div>
    
    <b-alert show variant="danger" class="row">
      <div class="col-6">
        <div>欢迎来到 <a href="/contact">自在量化!</a> 目标：量化市场一切，欢迎各位提出有效建议！</div>
      </div>
      <div class="col-3">
        <div>感谢<a href="/contact">捐赠</a>服务器费用：</div>
      </div>
      <WxShare />
    </b-alert>
    
    <!-- 使用懒加载组件，只在需要时加载 -->
    <div class="col-sm-12 col-md-6 col-lg-6 float-left">
      <component :is="sentimentHotTrend" v-if="showTrend" zoom_start="0"></component>
      <b-button v-else @click="loadTrend">加载热度趋势</b-button>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-6 float-left">
      <component :is="sentimentHotDay" v-if="showDay" zoom_start="45"></component>
      <b-button v-else @click="loadDay">加载热度日K</b-button>
    </div>
  </div>
</template>

<script>
import WxShare from '@/components/share/WxShare.vue'

export default {
  components: {
    WxShare
  },
  data() {
    return {
      sentimentHotTrend: null,
      sentimentHotDay: null,
      showTrend: false,
      showDay: false
    }
  },
  methods: {
    loadTrend() {
      import('components/sentiment/SentimentMarketHotTrend.vue').then(module => {
        this.sentimentHotTrend = module.default;
        this.showTrend = true;
      });
    },
    loadDay() {
      import('components/sentiment/SentimentMarketHotDay.vue').then(module => {
        this.sentimentHotDay = module.default;
        this.showDay = true;
      });
    }
  },
  // 可选：如果希望自动加载第一个组件
  mounted() {
    this.loadTrend();
    this.loadDay();
  }
}
</script>

<style scoped>
/* 确保首页图表高度不受其他页面影响 */
.chart_hot_trend,
.chart_hot_day {
  height: 400px !important;
  width: 100% !important;
}
</style>
